module.exports = __webpack_public_path__ + "static/img/news.f157ac3b.jpg";